import './skeleton.css'

export default function MFHeaderSkeleton() {
  return (
    <>
      <div className='flex justify-between items-center gap-[20px] pb-5 px-5 w-full'>
        <div className='flex flex-col gap-[6px] flex-1'>
          <div className='pb-[4px]'>
            <div className='skeleton h-[40px] w-[40px] rounded-[12px]'></div>
          </div>
          <div className='skeleton text-[16px] font-[500] text-[#28393E] leading-[130%] break-words rounded-[4px]'>
            &nbsp;
          </div>
          <div className='flex gap-[4px] text-13 text-[#6A6E6E] font-[400]'>
            {[1, 2, 3].map((_, idx) => (
              <div key={idx} className='flex items-center [&:last-child>.separator]:hidden'>
                <div className='skeleton w-[60px] h-[12px] rounded-[4px]'></div>
                <span className='pl-[4px] pt-[1px] separator'>
                  <div className='skeleton w-[4px] h-[5px] bg-gray-400 rounded-[4px]'></div>
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className='h-[104px] w-[104px] relative flex justify-center items-center'>
          {/* <div className='skeleton h-full w-full rounded-full'></div> */}
        </div>
      </div>
    </>
  )
}
